<script setup>
import Stock from "@/components/warehouse/Stock";
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
import Table from "@/components/common/other/Table";
import {inject, ref} from 'vue'
import {useStore} from 'vuex';

const store = useStore();

const stockSearch = inject('stockSearch');

const updateGridRender = ref();

</script>

<template>
<!--  <SlideInDrawer-->
<!--      :height="320"-->
<!--      title="Line Details"-->
<!--      v-model:open-drawer="stockSearch.openDetailsDrawer">-->
<!--    <div style="margin-top: 30px;">-->
<!--      <Table-->
<!--          :key="updateGridRender"-->
<!--          :allowGridMenu="false"-->
<!--          height="260"-->
<!--          :selectable="false"-->
<!--          :row-selection="false"-->
<!--          v-model:currentPage="stockSearch.lineGridCurrentPage"-->
<!--          v-model:currentPaginationRange="stockSearch.lineGridPageRange"-->
<!--          :dataSource="stockSearch.lineData"-->
<!--          :columns="stockSearch.tempLineCols">-->
<!--      </Table>-->
<!--    </div>-->
<!--  </SlideInDrawer>-->
  <Stock></Stock>
</template>

<style scoped>

</style>
